// extracted by mini-css-extract-plugin
export default {"button__text":"button_button__text__G3keF","button__loading":"button_button__loading__O5+3T","button-loader-spinner":"button_button-loader-spinner__UcXtL"};